import Vue from 'vue';
import { gameStore } from '@/store/game/store';
import { ActionMode, Action } from '@/store/game';
import { Client } from '@/client';
import { getInformantCardLetter } from '@/functions';
export default Vue.extend({
    computed: {
        visible() {
            return gameStore.state.ui.showInformantDlg;
        },
        informantCard() {
            return gameStore.state.ui.informantCardIndex ? getInformantCardLetter(gameStore.state.ui.informantCardIndex) : "";
        },
        glassBeneficiary() {
            const ben = gameStore.glassBeneficiary;
            return ben ? `a ${ben.name}` : "al tavolo";
        }
    },
    methods: {
        dismiss() {
            gameStore.commitToggleInformantDlg({ show: false });
        },
        getInformantCard() {
            Client.getInstance().send({
                action: Action.getInformantCard,
                cardIndex: gameStore.state.ui.informantCardIndex
            });
            this.dismiss();
        }
    }
})
